module.exports = __webpack_public_path__ + "img/almoosa-pharmacist.544c0dc7.jpg";